import React, { useLayoutEffect, useEffect, useState, useMemo, useRef } from "react";
import { Container, Row, Col, Image, Button, ListGroup } from "react-bootstrap";
import src from "../../assets/admin-bg.jpg";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { showAlert } from "../../components/common/showAlert";
import { useReactToPrint } from "react-to-print";
import { useSelector, useDispatch } from "react-redux";
import { myAccountActions, sendPhotosActions } from "../../_store";
import ConfirmationModal from "../../components/common/UI/Inputs/NotificationModal/BootstrapModalPopup";
import useFullPageLoader from "../../hooks/useFullPageLoader";
import NotificationService from "../../../src/ui/ui-modal-notification.js";
import { ReactNotifications } from "react-notifications-component";
import translations from '../../config/TranslateFile.jsx'
import { CreateEventLogTextFileForInbox } from "../../components/common/EventLog/EventLog.jsx";
import { storeCurrentRoute } from "../../utils/routeTracker.js";
import { getStoredValue, setStoredValue } from "../../_helpers/storagehelper.js";


const Profile = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const componentRef = useRef(); // Ref used for print - Purchase History Table Current Row.
  const PhotoCommID = location.state?.PhotoCommID; // Access the photo data
  const photo = useSelector((state) => state.sendPhotos.LoadPhotosDetailsResponse);
  const [loader, showLoader, hideLoader] = useFullPageLoader();
  const [isloading, setIsLoading] = useState(false);
  const CheckInmateConnectionStatus = useSelector((state) => state.sendPhotos.CheckInmateConnectionStatus);
  const currentMenuName = useSelector((x) => x.master.currentMenuName);
  const [disabledItems, setDisabledItems] = useState({
    newPhotos: false,
    photosHistory: false,
    purchaseCredits: false,
    cancelConnection: false,
    printPhoto: false,
  });
  const currentLang = translations();
  const UserID = getStoredValue("userID");
  const imagePath = photo?.PhotoAttachPath?.startsWith('/')
    ? photo?.PhotoAttachPath
    : `/${photo?.PhotoAttachPath}`;
  // const imageUrl = photo.IsPhotoBinarySave === 1
  //   ? `data:image/jpeg;base64,${photo.PhotoBinaryData}`  // Use the base64 data when PhotoBinarySave is 1
  //   : photo?.PhotoAttachPath;
  const imageUrl = photo.IsPhotoBinarySave === 1
    ? `data:image/jpeg;base64,${photo.PhotoBinaryData}`  // Use the base64 data when PhotoBinarySave is 1
    : photo?.PhotoAttachPath;

  const myAccountDetails = useSelector(
    (state) => state.myAccount.LoadPublicUserDetails
  );
  const UpdateInmateConnectionResponse = useSelector(
    (state) => state.sendPhotos.UpdateInmateConnection
  );
  const [isPrintData, setIsPrintData] = useState(false);

  const [photos, setPhoto] = useState(null); // State to store the selected photo data
  const [isNewPhotoConfirmation, setIsNewPhotoConfirmation] = useState(false);
  const [isPurchaseHistoryConfirm, setIsPurchaseHistoryConfirm] = useState(false);
  const [isConnectionConfirm, setIsConnectionConfirm] = useState(false);
  const [paymentMsg, setPaymentMsg] = useState("");
  const [isPaymentMsg, setIsPaymentMsg] = useState(false);
  const [inmateID, setInmateID] = useState("");
  const [isCreditamountModal, setisCreditamountModal] = useState(false);
  const [msgCreditamount, setMsgCreditamount] = useState("");

  // useEffect(() => {
  //   showLoader(); setIsLoading(true);
  // }, [imageUrl])

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);

  const handleHistoryClick = (InmateID, User) => {
    const updatedFindPhotos = {
      ...location.state?.findPhotos, // Spread current `findPhotos` to retain existing values
      InmateID: InmateID,
      userID: parseInt(UserID),
    };
    navigate("/public/SentPhotos", { state: { findPhotos: updatedFindPhotos, IsUser: User } });
    storeCurrentRoute("/public/SentPhotos");
  };

  const handleClickSearch = () => {
    navigate("/public/SentPhotos", { state: { findPhotos: location.state?.findPhotos } });
    storeCurrentRoute("/public/SentPhotos");
    dispatch(sendPhotosActions.clearPhotosDetailsResponse());
  }

  const handleSendPhoto = (InmateID) => {
    setIsNewPhotoConfirmation(true);
    setInmateID(InmateID);

    const infoMessage = "Sent Photos Menu - Show Confirmation Message Popup to Redirect Write message page for Send New photos";
    const redirectURL = "--------------";
    const Status =
      "Shows YES or No Confirmation popup";
    const Response = "This action redirects into another page, Are you sure you want to proceed?";
    CreateEventLogTextFileForInbox(dispatch, infoMessage, redirectURL, Response, Status);
  };


  useEffect(() => {
    if (PhotoCommID) {
      setDisabledItems({
        newPhotos: false,
        photosHistory: false,
        purchaseCredits: false,
        cancelConnection: false,
        printPhoto: false
      });

      LoadPhotosDetails();
    }
  }, [PhotoCommID, dispatch]);

  useLayoutEffect(() => {
    if (photo.length === undefined) {
      if (photo.IsAllowSendReply !== 1) {
        setDisabledItems({
          newPhotos: true,
          photosHistory: false,
          purchaseCredits: true,
          cancelConnection: true,
          printPhoto: false,
        });
        if (photo.ActiveStatus !== 1) {
          setDisabledItems((prevState) => ({
            ...prevState,       // Preserve previous state
            newPhotos: true,
            purchaseCredits: true,
            cancelConnection: true,
          }));
        }
        else if (photo.InmateStatus === 0) {
          let IsCancelConnection = true;
          if (photo.ConnectionStatusID === 2) {
            IsCancelConnection = false;
          } else {
            IsCancelConnection = true;
          }
          setDisabledItems((prevState) => ({
            ...prevState,       // Preserve previous state
            newPhotos: true,
            purchaseCredits: true,
            cancelConnection: IsCancelConnection,
          }));
        }
        else if (photo.IsAllowSendReply != 1 && photo.ConnectionStatusID == 2) {
          setDisabledItems((prevState) => ({
            ...prevState,       // Preserve previous state
            purchaseCredits: false,
            cancelConnection: false,
          }));
        }
      }
      else {
        setDisabledItems((prevState) => ({
          ...prevState,       // Preserve previous state
          newPhotos: false,
          purchaseCredits: false,
          cancelConnection: false
        }));
      }

      if (photo.Blocked === 1) {
        setDisabledItems((prevState) => ({
          ...prevState,
          newPhotos: true,
          purchaseCredits: true
        }));
      }
      else if (photo.PhotoLockdown === 1 || photo.PhotoPODAccess === 0) {
        setDisabledItems((prevState) => ({
          ...prevState,       // Preserve previous state
          newPhotos: true     // Update only the newPhotos property
        }));

      }
    }
  }, [photo]);


  const handlemsgPhotoStatusResponse = (MsgPhotoStatusResponse) => {
    if (MsgPhotoStatusResponse) {
      const { Result, Notes } = MsgPhotoStatusResponse;
      switch (Result) {
        case -7:
          setPaymentMsg(currentLang?.ArchivedPagePopContent?.Connection_Blocked);
          setIsPaymentMsg(true);
          setDisabledItems({
            newPhotos: true,
            photosHistory: false,
            purchaseCredits: true,
            cancelConnection: true,
            printPhoto: false,
          });
          dispatch(sendPhotosActions.clearMsgPhotoStatusResponse());
          break;
        case -8:
          setPaymentMsg(currentLang?.ArchivedPagePopContent?.No_longer_connected);
          setIsPaymentMsg(true);
          setDisabledItems({
            newPhotos: true,
            photosHistory: false,
            purchaseCredits: true,
            cancelConnection: true,
            printPhoto: false,
          });
          dispatch(sendPhotosActions.clearMsgPhotoStatusResponse());
          break;
        case -6:
          setPaymentMsg(currentLang?.ArchivedPagePopContent?.Disabled_Contact);
          setIsPaymentMsg(true);
          setDisabledItems({
            newPhotos: true,
            photosHistory: false,
            purchaseCredits: true,
            cancelConnection: false,
            printPhoto: false,
          });
          dispatch(sendPhotosActions.clearMsgPhotoStatusResponse());
          break;
        case -4:
          setPaymentMsg(currentLang?.ArchivedPagePopContent?.Disabled_Facility);
          setIsPaymentMsg(true);
          setDisabledItems({
            newPhotos: true,
            photosHistory: false,
            purchaseCredits: true,
            cancelConnection: false,
            printPhoto: false,
          });
          dispatch(sendPhotosActions.clearMsgPhotoStatusResponse());
          break;
        case -3:
          setPaymentMsg(Notes);
          setIsPaymentMsg(true);
          setDisabledItems({
            newPhotos: false,
            photosHistory: false,
            purchaseCredits: true,
            cancelConnection: false,
            printPhoto: false,
          });
          dispatch(sendPhotosActions.clearMsgPhotoStatusResponse());
          break;
        default:
          if (Result === 0) {
            // If success response (result = 0), redirect
            setStoredValue("InmateID", inmateID);
            navigate("/public/PurchaseCredits", {
              state: { previousPath: location.pathname },
            });
            storeCurrentRoute("/public/PurchaseCredits");
            dispatch(sendPhotosActions.clearMsgPhotoStatusResponse());

          }
          break;
      }
      handleCancelPurchaseHist();
      LoadPhotosDetails();
    }
  }

  const LoadPhotosDetails = () => {
    if (PhotoCommID) {
      showLoader(); setIsLoading(true);
      dispatch(sendPhotosActions.LoadPhotosDetails({ PhotoCommID })).then((x) => {
        hideLoader(); setIsLoading(false);
      });
    }
  }

  const handleClickRedirectPurchaseridet = () => {
    showLoader(); setIsLoading(true);
    dispatch(
      sendPhotosActions.CheckingMsgPhotoStatus({
        addFormData: { UserID: UserID, PhotoInmateID: inmateID },
      })
    ).then((x) => { handlemsgPhotoStatusResponse(x?.payload) });
    setStoredValue("InmateID", inmateID);
    navigate("/public/PurchaseCredits", {
      state: { previousPath: location.pathname },
    });
    storeCurrentRoute("/public/PurchaseCredits");
    hideLoader(); setIsLoading(false);
  };

  // Purchase Histroy Table - (Particular row print option)
  const handlePrintShow = () => {
    const infoMessage = `Send Photos Menu - Clicked Print Photo button ( PhotoCommID - ${PhotoCommID} )`;
    const redirectURL = "---";
    const Status = "Print Photos Conversation";
    const Response = "---";

    CreateEventLogTextFileForInbox(dispatch, infoMessage, redirectURL, Response, Status);

    setPhoto(photos); // Set the photo data to state
    setIsPrintData(true); // Show the print content
    setTimeout(() => {
      handlePrints(); // Trigger print after a short delay to allow rendering
    }, 10);
  };

  const handlePrints = useReactToPrint({
    pageStyle: `@media print {
            @page {
              // size: 4in 5in;
               size: portrait;
              margin: 0 !important;
              padding: 0 !important;
            }
          }`,

    content: () => componentRef.current,
    onBeforeGetContent: () => { },
  });

  // result for photos status
  useEffect(() => {
    if (CheckInmateConnectionStatus != null) {
      const InmateDetails = CheckInmateConnectionStatus;
      if (InmateDetails.length > 0) {
        setIsNewPhotoConfirmation(false);
        if (InmateDetails[0].ConnectionStatusID == 3 || InmateDetails[0].ConnectionStatusID == 4 || InmateDetails[0].ConnectionStatusID == 5) {
          setPaymentMsg(currentLang?.ArchivedPagePopContent?.Connection_Blocked);
          setIsPaymentMsg(true);
          setDisabledItems({
            newPhotos: true,
            photosHistory: false,
            purchaseCredits: true,
            cancelConnection: true,
            printPhoto: false,
          });
          dispatch(sendPhotosActions.clearInmateConnectionStatusResponse());
        }
        else if (InmateDetails[0].IsPhotoAccess == 0 || InmateDetails[0].PhotoAccess == 0) {
          setPaymentMsg(currentLang?.ECardPopContent?.Restricted_SentPhotos);
          setIsPaymentMsg(true);
          setDisabledItems({
            newPhotos: true,
            photosHistory: false,
            purchaseCredits: false,
            cancelConnection: false,
            printPhoto: false,
          });
          dispatch(sendPhotosActions.clearInmateConnectionStatusResponse());
        }
        else if (InmateDetails[0].ActiveStatus == 0) {
          setPaymentMsg("You are no longer connected with this user.");
          setIsPaymentMsg(true);
          setDisabledItems({
            newPhotos: true,
            photosHistory: false,
            purchaseCredits: true,
            cancelConnection: true,
            printPhoto: false,
          });
          dispatch(sendPhotosActions.clearInmateConnectionStatusResponse());
        }
        else if (InmateDetails[0].Blocked == 1) {
          setPaymentMsg(currentLang?.ECardPopContent?.Restricted_SentPhotos);
          setIsPaymentMsg(true);
          setDisabledItems({
            newPhotos: true,
            photosHistory: false,
            purchaseCredits: true,
            cancelConnection: true,
            printPhoto: false,
          });
          dispatch(sendPhotosActions.clearInmateConnectionStatusResponse());
        }
        else if (InmateDetails[0].PhotoLockdown == 1 || InmateDetails[0].PhotoPODAccess == 0) {
          setPaymentMsg(currentLang?.ECardPopContent?.Restricted_SentPhotos);
          setIsPaymentMsg(true);
          setDisabledItems({
            newPhotos: true,
            photosHistory: false,
            purchaseCredits: false,
            cancelConnection: false,
            printPhoto: false,
          });
          dispatch(sendPhotosActions.clearInmateConnectionStatusResponse());
        }
        else {
          navigate("/public/WriteMessage", {
            state: { PhotoInmateID: inmateID },
          });
          storeCurrentRoute("/public/WriteMessage");
          dispatch(sendPhotosActions.clearInmateConnectionStatusResponse());
        }
      }
    }
  }, [CheckInmateConnectionStatus, dispatch]);

  useEffect(() => {
    if (UpdateInmateConnectionResponse === 1) {
      dispatch(sendPhotosActions.clearEmailResponse());
      NotificationService({
        title: currentLang?.Message,
        message: currentLang?.ECardPopContent?.Request_Cancelled_Success,
        type: "success",
      });
      CreateEventLogTextFileForInbox(
        dispatch,
        `Cancel Public User - Inmate Connection ( PUIConnectionID - "${photo.PUIConnectionID}" ) `,
        "---",
        "---",
        "Request Canceled successfully",
      );
      LoadPhotosDetails();
    } else if (UpdateInmateConnectionResponse === -1) {
      dispatch(sendPhotosActions.clearEmailResponse());
      NotificationService({
        title: currentLang?.Message,
        message: currentLang?.InboxPopContent?.Operation_Failed,
        type: "error",
      });
      CreateEventLogTextFileForInbox(
        dispatch,
        `Cancel Public User - Inmate Connection ( PUIConnectionID - "${photo.PUIConnectionID}" ) `,
        "---",
        "---",
        "Operation Failed",
      );
    } else if (UpdateInmateConnectionResponse === -2) {
      dispatch(sendPhotosActions.clearEmailResponse());
      NotificationService({
        title: currentLang?.Message,
        message: currentLang?.InboxPopContent?.Not_Request_Rejected_ByInmate,
        type: "warning",
      });
      CreateEventLogTextFileForInbox(
        dispatch,
        `Cancel Public User - Inmate Connection ( PUIConnectionID - "${photo.PUIConnectionID}" ) `,
        "---",
        "---",
        "Current Connection Status is Not Request Rejected By Inmate",
      );
      LoadPhotosDetails();
    } else if (UpdateInmateConnectionResponse === -3) {
      dispatch(sendPhotosActions.clearEmailResponse());
      NotificationService({
        title: currentLang?.Message,
        message: currentLang?.InboxPopContent?.Not_Request_Accept_ByInmate,
        type: "warning",
      });
      CreateEventLogTextFileForInbox(
        dispatch,
        `Cancel Public User - Inmate Connection ( PUIConnectionID - "${photo.PUIConnectionID}" ) `,
        "---",
        "---",
        "Current Connection Status is Not Request Accept By Inmate",
      );
      LoadPhotosDetails();
    } else if (UpdateInmateConnectionResponse === -4) {
      dispatch(sendPhotosActions.clearEmailResponse());
      NotificationService({
        title: currentLang?.Message,
        message: currentLang?.InboxPopContent?.Not_Request_Rejected_ByPU,
        type: "warning",
      });
      CreateEventLogTextFileForInbox(
        dispatch,
        `Cancel Public User - Inmate Connection ( PUIConnectionID - "${photo.PUIConnectionID}" ) `,
        "---",
        "---",
        "Current Connection Status is Not Request Cancel By Public User",
      );
      LoadPhotosDetails();
    } else if (UpdateInmateConnectionResponse === -5) {
      dispatch(sendPhotosActions.clearEmailResponse());
      NotificationService({
        title: currentLang?.Message,
        message: currentLang?.InboxPopContent?.Not_Request_Accept_ByPU,
        type: "warning",
      });
      CreateEventLogTextFileForInbox(
        dispatch,
        `Cancel Public User - Inmate Connection ( PUIConnectionID - "${photo.PUIConnectionID}" ) `,
        "---",
        "---",
        "Current Connection Status is Not Request Accept By Public User",
      );
      LoadPhotosDetails();
    } else if (UpdateInmateConnectionResponse === -6) {
      dispatch(sendPhotosActions.clearEmailResponse());
      NotificationService({
        title: currentLang?.Message,
        message: currentLang?.InboxPopContent?.Inmate_Limit_Exceeded,
        type: "warning",
      });
      CreateEventLogTextFileForInbox(
        dispatch,
        `Cancel Public User - Inmate Connection ( PUIConnectionID - "${photo.PUIConnectionID}" ) `,
        "---",
        "---",
        "The Inmate Connection Limit Exceeded ",
      );
    }
  }, [UpdateInmateConnectionResponse]);

  const handleCancelMessage = () => {
    setIsNewPhotoConfirmation(false);

    const infoMessage = "Sent Photos Menu - Clicked NO option In Redirect into Send Photo confirmation Popup";
    const redirectURL = "---";
    const Status = "Hided confirmation Popup";
    const Response = "---";

    CreateEventLogTextFileForInbox(dispatch, infoMessage, redirectURL, Response, Status);
  };

  const handleCancelPurchaseHist = () => {
    setIsPurchaseHistoryConfirm(false);

    const infoMessage = "Sent Photos Menu - Clicked NO option In Redirect into Purchase Credit confirmation Popup";
    const redirectURL = "---";
    const Status = "Hided confirmation Popup";
    const Response = "---";

    CreateEventLogTextFileForInbox(dispatch, infoMessage, redirectURL, Response, Status);
  };

  const handleCancelConnection = () => {
    setIsConnectionConfirm(false);

    const infoMessage = "Sent Photos Menu - Clicked NO option In Cancel Connection confirmation Popup";
    const redirectURL = "---";
    const Status = "Hided confirmation Popup";
    const Response = "---";

    CreateEventLogTextFileForInbox(dispatch, infoMessage, redirectURL, Response, Status);
  };

  const handlePaymentMsg = () => {
    setIsPaymentMsg(false);
  };
  // Redirect to write message/Photo page
  const handleClickRedirect = () => {

    const infoMessage = `Redirect into Write Message/ Photo page to sent New Photo ( - "${photo?.InmateID}") `;
    const redirectURL = "public/WriteMessage";
    const Status = "---";
    const Response = "---";
    CreateEventLogTextFileForInbox(dispatch, infoMessage, redirectURL, Response, Status);

    if (photo.CreditBalance <= 0) {

      setisCreditamountModal(true);
      setMsgCreditamount(currentLang?.ECardPopContent?.Low_balance_Photo);
    } else if (photo?.CreditBalance < photo?.FacilityPhotoCost) {
      setisCreditamountModal(true);
      setMsgCreditamount(currentLang?.ECardPopContent?.Low_balance_Photo);
    }
    else {
      showLoader(); setIsLoading(true);
      dispatch(sendPhotosActions.LoadPublicInmateConnectionDet({ userID: UserID, inmatesID: inmateID }));
      hideLoader(); setIsLoading(false);

    }

  };

  // Redirect to purchase credit page
  const handleClickPurchaseCreditRedirect = () => {
    showLoader(); setIsLoading(true);
    const infoMessage = `Redirect into Purchase Credits page to Purchase Credits for Inmate ( Inmate ID - " ${photo?.InmateID} " ) `;
    const redirectURL = "/public/PurchaseCredits";
    const Status = "---";
    const Response = "---";
    CreateEventLogTextFileForInbox(dispatch, infoMessage, redirectURL, Response, Status);
    dispatch(sendPhotosActions.CheckingMsgPhotoStatus({ addFormData: { UserID: UserID, InmateID: inmateID } })).then((x) => { handlemsgPhotoStatusResponse(x?.payload) });
    hideLoader(); setIsLoading(false);
  }

  // Back Sent Photos page
  const handleClickPurchaseCredit = (InmateID) => {
    setIsPurchaseHistoryConfirm(true);
    setInmateID(InmateID);

    const infoMessage = "Sent Photos Menu - Show Confirmation Message Popup to Redirect Purchase Credit page";
    const redirectURL = "---";
    const Status = "Shows YES or No Confirmation popup";
    const Response = "This action redirects into another page, Are you sure you want to proceed?";

    CreateEventLogTextFileForInbox(dispatch, infoMessage, redirectURL, Response, Status);
  };

  const handleClickConnection = () => {
    setIsConnectionConfirm(true);

    const infoMessage = "Sent Photos Menu - Show Confirmation Message Popup to Cancel Connection Request";
    const redirectURL = "---";
    const Status = "Shows YES or No Confirmation popup";
    const Response = "---";

    CreateEventLogTextFileForInbox(dispatch, infoMessage, redirectURL, Response, Status);
  };

  const handleClickUpdateConnection = () => {
    dispatch(
      sendPhotosActions.UpdateInmateConnection({
        PUIConnectionID: photo.PUIConnectionID,
        UserID: photo.PublicUserID,
        InmatesId: photo.InmateID,
        FacilityID: photo.facilityID,
        RequestChangeUser: photo.Sender,
        ToConnectionStatusID: "3",
        Action: 0,
        IsSALoginAsPU: 0,
        InmateResidentID: "",
        RelationShip: "",
        InmateInvitePublicUserID: photo?.PublicUserID,
      }), // No action for the confirm button
      true, // Show Yes/No buttons
      currentLang?.buttons?.No // Cancel button text
    );
    setIsConnectionConfirm(false);

  };

  const handleImageLoad = () => {
    hideLoader(); setIsLoading(false);
  }

  return (
    <>
      <ReactNotifications />
      <Container fluid className="p-1" style={{ minHeight: "100vh" }}>
        <div className="d-flex justify-content-between align-items-center">
          <div className="header-title">
            <h5>
              {currentLang?.sendphotos}
            </h5>
          </div>
        </div>
        <div className="card shadow-sm p-3">
          <div className="d-flex align-items-center gap-3">
            <div className="align-items-center">
              {/* Left arrow icon with click handler */}
              <i
                className="fa fa-chevron-left me-2"
                style={{ cursor: "pointer" }}
                onClick={() => handleClickSearch(photo.InmateID, false)}
              ></i>

              {/* Profile icon with redirect link */}
              <Link to="/public/SentPhotos">
                {/* <div className="profile-icon bg-dark rounded-circle text-white d-flex justify-content-center align-items-center">
                  <i className="bi bi-person fs-4"></i>
                </div> */}
              </Link>
            </div>
            <div>
              <h5 className="mb-0">{photo.PhotoTo}</h5>
              <h6>
                {currentLang?.inbox?.Subject}: <span className="text-muted">{photo.PhotoSubject}</span>
              </h6>
            </div>
          </div>
        </div>

        {/* Image and Sidebar Section */}
        <Row className="mt-2 mb-80" style={{ height: "100%" }}>
          <Col className="d-flex align-items-stretch col-12 col-md-12 col-lg-8">
            <div className="card shadow-sm border-radius-all p-3 mb-3" style={{
              flex: 1,
              width: '500px',
              height: '500px',
              overflow: 'hidden',
              position: 'relative',
            }}>
              {!isloading && <img
                src={imageUrl}
                alt="ConversationPhoto"
                className="img-fluid rounded"
                style={{
                  width: "100%", // Ensure it takes up the full width
                  height: "100%",
                  objectFit: "contain", // Ensures the image scales correctly without distorting
                }}
                onError={(e) =>
                  (e.target.src = "https://via.placeholder.com/300")
                } // Fallback image
              />}
            </div>
          </Col>

          <Col className="d-flex col-12 col-md-12 col-lg-4">
            <div
              className="card shadow-sm p-2 mb-3"
              style={{
                height: "auto",
                flex: 1, // Allow this column to stretch and match the height of the image column
              }}
            >
              <div className="text-center mb-4 mt-3 mb-80">
                <strong className="fs-2">{currentLang?.AvailableCredits}</strong>
                <strong
                  className={`fs-2 ${photo.CreditBalance > 0 ? "txt-success" : "text-danger"}`}
                >
                  {" $"}{parseFloat(photo.CreditBalance).toFixed(2)}
                </strong>
              </div>
              <ul className="submenu-list">
                {/* --------------------------------- Menu for New Photos -------------------------------------------------- */}
                <li
                  className={`ActiveSubmenu ${disabledItems["newPhotos"] ? "opacity-50 no-hover" : ""
                    }`}
                  title={
                    disabledItems["newPhotos"]
                      ? currentLang?.tooltip?.permission
                      : currentLang?.sentPhotos?.NewPhotos
                  }
                  onClick={
                    !disabledItems["newPhotos"] ? () => handleSendPhoto(photo.InmateID) : undefined
                  }
                >
                  {currentLang?.sentPhotos?.NewPhotos}
                  <label className="pointer float-end">
                    <i class="fa-solid fa-envelope"></i>
                  </label>
                </li>
                {/* --------------------------------- Menu for Photos History -------------------------------------------- */}
                <li
                  className={`ActiveSubmenu ${disabledItems["photosHistory"] ? "opacity-50 no-hover" : ""
                    }`}
                  title={
                    disabledItems["photosHistory"]
                      ? currentLang?.tooltip?.permission
                      : currentLang?.sentPhotos?.PhotosHistory
                  }
                  onClick={
                    !disabledItems["photosHistory"] ? () => handleHistoryClick(photo.InmateID, true) : undefined
                  }
                >
                  {currentLang?.sentPhotos?.PhotosHistory}
                  <label className="pointer float-end">
                    <i className="fa fa-archive pointer"></i>
                  </label>
                </li>
                {/* -------------------------------- Menu for Purchase Credits ------------------------------------------------ */}
                <li
                  className={`ActiveSubmenu ${disabledItems["purchaseCredits"] ? "opacity-50 no-hover" : ""
                    }`}
                  title={
                    disabledItems["purchaseCredits"]
                      ? currentLang?.tooltip?.permission
                      : currentLang?.inbox?.PurchaseCredits
                  }
                  onClick={
                    !disabledItems["purchaseCredits"] ? () => handleClickPurchaseCredit(photo.InmateID) : undefined
                  }
                >
                  {currentLang?.inbox?.PurchaseCredits}
                  <label className="pointer float-end">
                    <i className="fa fa-shopping-cart pointer"></i>
                  </label>
                </li>
                {/* ------------------------------------ Cancel Connection Menu ------------------------------------------------- */}
                <li
                  className={`ActiveSubmenu ${disabledItems["cancelConnection"] ? "opacity-50 no-hover" : ""
                    }`}
                  title={
                    disabledItems["cancelConnection"]
                      ? currentLang?.tooltip?.permission
                      : currentLang?.inbox?.CancelConnection
                  }
                  onClick={
                    !disabledItems["cancelConnection"] ? handleClickConnection : undefined
                  }
                >
                  {currentLang?.inbox?.CancelConnection}
                  <label className="pointer float-end">
                    <i className="fa fa-times-circle pointer"></i>
                  </label>
                </li>
                {/* ------------------------------------ Print Photo - Menu ------------------------------------------------- */}
                <li
                  className="ActiveSubmenu"
                  title={currentLang?.sentPhotos?.PrintPhoto}
                  onClick={handlePrintShow}
                >
                  {currentLang?.sentPhotos?.PrintPhoto}
                  <label className="pointer float-end">
                    <i className="fa fa-print pointer"></i>
                  </label>
                </li>
              </ul>

            </div>
          </Col>
        </Row>

        {/* Print Section (Hidden by Default) */}

        <div style={{ display: "none" }}>
          <form ref={componentRef} style={isPrintData ? { display: "block" } : { display: "none" }}>
            <div className="container-fluid">
              <div className="w-100">
                <div className="d-flex justify-content-start mb-2">
                  <p className="mb-0">{new Date().toLocaleString()}</p>
                </div>
                <div className="p-4">
                  <h3 className="text-start font-size-20">{currentLang?.PhotoPage?.PHOTO_CONVERSATION}</h3>
                  <hr />
                  <h5 className="text-left" style={{ fontStyle: 'italic', fontSize: '15px' }}>{photo.PhotoSentDate}</h5>

                  {/* Updated Content Section (Table Concept with 2 Columns) */}
                  <div className="table-responsive" style={{ fontSize: '18px' }}>
                    <table className="table table-bordered">
                      <tbody>
                        {[
                          { label: currentLang?.labels?.From, value: photo?.PhotoFrom },
                          { label: currentLang?.labels?.To, value: photo.PhotoTo },
                          { label: currentLang?.labels?.Subject, value: photo.PhotoSubject },
                          { label: currentLang?.labels?.Status_by_Admin, value: photo.PhotoActionStatus ? photo.PhotoActionStatus : "Waiting" },
                          { label: currentLang?.labels?.Status_by_Inmate, value: photo.PhotoReadStatus },
                        ].map((row, index) => (
                          <tr key={index}>
                            <td className="fw-700" style={{ width: "30%", paddingRight: "10px", borderRight: "2px solid #ddd" }}>
                              {row.label}
                            </td>
                            {/* Right column without a left border */}
                            <td style={{ width: "70%" }}>
                              {row.value}
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>

              {/* Full Width Image Section */}
              <div className="text-center mt-3">
                <img
                  src={imageUrl}
                  alt="ConversationPhoto"
                  className="img-fluid rounded"
                  style={{
                    width: "100%", // Full width for the photo
                    height: "600px",
                    border: "1px solid #ddd"
                  }}
                  // onLoad={handleImageLoad}
                  onError={(e) =>
                    (e.target.src = "https://via.placeholder.com/300") // Fallback image
                  }
                />
              </div>
            </div>
          </form>
        </div>
        {loader}
        <ConfirmationModal
          show={isNewPhotoConfirmation}
          onHide={handleCancelMessage}
          onConfirm={handleClickRedirect}
          title={currentLang?.Message}
          message={currentLang?.InboxPopContent?.Redirect_Page}
          onconfirmname={currentLang?.buttons?.Yes}
          oncancelname={currentLang?.buttons?.No}
        />

        <ConfirmationModal
          show={isPurchaseHistoryConfirm}
          onHide={handleCancelPurchaseHist}
          onConfirm={handleClickPurchaseCreditRedirect}
          title={currentLang?.Message}
          message={currentLang?.InboxPopContent?.Redirect_Page}
          onconfirmname={currentLang?.buttons?.Yes}
          oncancelname={currentLang?.buttons?.No}
        />
        <ConfirmationModal
          show={isConnectionConfirm}
          onHide={handleCancelConnection}
          onConfirm={handleClickUpdateConnection}
          title={currentLang?.Message}
          message={currentLang?.InboxPopContent?.Cancel_Connection}
          onconfirmname={currentLang?.buttons?.Yes}
          oncancelname={currentLang?.buttons?.No}
        />
        <ConfirmationModal
          show={isPaymentMsg}
          onHide={handlePaymentMsg}
          onConfirm={handlePaymentMsg}
          title={currentLang?.Message}
          message={paymentMsg}
          showCancelButton={false}
          onconfirmname={currentLang?.buttons?.OK}
        />
        {/* Modal Popup for redirect purchase credit */}
        <ConfirmationModal
          show={isCreditamountModal}
          // onHide={handleCancelMessage}
          onConfirm={handleClickRedirectPurchaseridet}
          title={currentLang?.Message}
          message={msgCreditamount}
          showCancelButton={false} // Pass 'false' to hide the "No" button
          messageColor="#FF7F7F"
          size={"lg"}
          onconfirmname={currentLang?.buttons?.Yes}
          closeButton={false}
        />

      </Container>
    </>
  );
};

export default React.memo(Profile);
